<template>
    <div>
        <div class="row">
            <div class="col-lg-12 text-center">
            </div>
        </div>
    </div>
</template>


<script>

    export default {
        name: 'login-without-company',
        data() {
            return {}
        },
        methods: {}
    }
</script>
